export const UserTypes = {
  firstClass: 'firstClass',
  businessClass: 'businessClass',
  free: 'free',
};

export default 'constants.js';
